import { isToggleEnabled } from 'configs/toggle-feature'
import { KSProposalPage } from 'app/BCKSPage/KSProposal/KSProposalPage'
import MaintenanceModePage from 'app/BCKSPage/MaintenanceMode'

interface PageProps {
  isKSSelectionEnabled: boolean
}

export const getServerSideProps = async () => {
  const isKSSelectionEnabled = await isToggleEnabled('ks-selection-enabled')

  return {
    props: {
      isKSSelectionEnabled,
    },
  }
}

const Page = (props: PageProps) => {
  if (!props.isKSSelectionEnabled) {
    return <MaintenanceModePage />
  }

  return <KSProposalPage />
}

export default Page
